module.exports = __webpack_public_path__ + "static/blog_insurance-f7d6d155b99294e72fdb79e3501360dd.jpg";